<template>
  <b-form @submit="onSubmit">
    <b-form-file
      v-model="form.list"
      :state="Boolean(form.list)"
      placeholder="Choisissez un fichier ou déposez-le ici..."
      drop-placeholder="Déposez-le ici..."
      accept=".csv, .xls, .xlsx"
    />
    <div
      v-if="form.list"
      class="mt-3">Fichier sélectionné: {{ form.list ? form.list.name : '' }}</div>
    <b-button
      :disabled="buttonDisabled"
      class="ani-flex-auto"
      type="submit"
      variant="success">Importer</b-button>
  </b-form>
</template>

<script>
export default {
  name: 'FormImportList',
  props: {
    id: {
      type: Number,
      default: null,
    },
    buttonDisabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        list: null,
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      const formData = new FormData();
      formData.append('file', this.form.list);
      this.$emit('sendForm', formData);
    },
  },
};
</script>

<style scoped>
  .ani-flex-auto {
    display: flex;
    margin: 20px auto auto auto;
  }
</style>
